import React from "react";
import styled from "@emotion/styled";

const StyledButton = styled.span`
  color: #5e6f64;
  font-weight: bold;
  border: solid #5e6f64 1px;
  padding: 0.1em 0.6em;
  box-shadow: 1px 1px 14px rgba(0, 0, 0, 0.2);
  padding: 1em;
  display: block;
  text-align: center;
  margin: 1rem 0;

  &:hover {
    background: #5e6f64;
    color: white;
    border: solid white 1px;
    transition: background-color 0.3s;
  }
  @media (min-width: 480px) {
    & {
      padding: 0.6rem;
      display: block;
    }
    @media (min-width: 1200px) {
      & {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        padding: 0.8rem;
      }
    }
  }
`;

const LinkButton = ({ to, children }) => {
  return (
    <a href={to ? to : "#!"}>
      <StyledButton>{children}</StyledButton>
    </a>
  );
};

export default LinkButton;
